import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as ReactDOMClient from 'react-dom/client';
import * as ReactHookForm from 'react-hook-form';
import * as ReactI18next from 'react-i18next';
import * as ReactRouterDOM from 'react-router-dom';
import * as ReactTransitionGroup from 'react-transition-group';
import * as ReactUse from 'react-use';
import * as BifrostKeycloakClient from '@bifrost/keycloak-client';
import * as BifrostWebComponents from '@bifrost/web-components';
import * as BifrostWebTemplates from '@bifrost/web-templates';
import * as Connect from '@connectrpc/connect';
import * as ConnectQuery from '@connectrpc/connect-query';
import * as ConnectWeb from '@connectrpc/connect-web';
import * as CrowdinOTAClient from '@crowdin/ota-client';
import * as DNDCore from '@dnd-kit/core';
import * as DNDModifiers from '@dnd-kit/modifiers';
import * as DNDSortable from '@dnd-kit/sortable';
import * as HookformResolvers from '@hookform/resolvers';
import * as ReactQuery from '@tanstack/react-query';
import * as DayJS from 'dayjs';
import * as I18next from 'i18next';
import * as Lodash from 'lodash';
import * as Zod from 'zod';
import 'systemjs';
import 'import-map-overrides';
System.set('dependencies:react', React);
System.set('dependencies:react-dom', ReactDOM);
System.set('dependencies:react-dom/client', ReactDOMClient);
System.set('dependencies:react-use', ReactUse);
System.set('dependencies:react-router-dom', ReactRouterDOM);
System.set('dependencies:react-hook-form', ReactHookForm);
System.set('dependencies:react-transition-group', ReactTransitionGroup);
System.set('dependencies:dayjs', DayJS);
System.set('dependencies:@dnd-kit/core', DNDCore);
System.set('dependencies:@dnd-kit/modifiers', DNDModifiers);
System.set('dependencies:@dnd-kit/sortable', DNDSortable);
System.set('dependencies:lodash', Lodash);
System.set('dependencies:@connectrpc/connect', Connect);
System.set('dependencies:@connectrpc/connect-query', ConnectQuery);
System.set('dependencies:@connectrpc/connect-web', ConnectWeb);
System.set('dependencies:@tanstack/react-query', ReactQuery);
System.set('dependencies:@bifrost/web-components', BifrostWebComponents);
System.set('dependencies:@bifrost/web-templates', BifrostWebTemplates);
System.set('dependencies:@bifrost/keycloak-client', BifrostKeycloakClient);
System.set('dependencies:i18next', I18next);
System.set('dependencies:react-i18next', ReactI18next);
System.set('dependencies:zod', Zod);
System.set('dependencies:@hookform/resolvers', HookformResolvers);
System.set('dependencies:@crowdin/ota-client', CrowdinOTAClient);
